import { CompanyUser, CompanyUserReviewStatus } from '__generated__/GQL';

/**
 * Returns true if a company user can edit their personnal information
 */
const canEditPersonalInformation = ({
  companyUser,
  companyUsers,
  isNewOnboardingAllowed,
}: {
  isNewOnboardingAllowed: boolean;
  companyUser: Pick<CompanyUser, 'isMandatee'> | null;
  companyUsers: Pick<CompanyUser, 'reviewStatus'>[] | null;
}): boolean => {
  // If the company user is null, they're doing their first onboarding
  if (companyUser === null) {
    return true;
  }

  if (companyUser.isMandatee) {
    return isNewOnboardingAllowed === false;
  }

  const hasValidatedCompany = companyUsers?.some(
    (user) => user.reviewStatus === CompanyUserReviewStatus.Validated,
  );

  return !hasValidatedCompany;
};

export default canEditPersonalInformation;
